var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.91,
    height: 23.128,
    viewBox: "0 0 21.91 23.128",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M4.854,16a1.217,1.217,0,0,1,1.217,1.217v2.434a1.217,1.217,0,0,0,.357.861h0a1.217,1.217,0,0,0,.861.357H21.9a1.217,1.217,0,0,0,1.217-1.217V17.217a1.217,1.217,0,1,1,2.434,0v2.434A3.652,3.652,0,0,1,21.9,23.3H7.288a3.652,3.652,0,0,1-3.652-3.652V17.217A1.217,1.217,0,0,1,4.854,16Z",
    transform: "translate(-3.637 -0.176)",
    fill: "#1383be",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M6.993,10.357a1.217,1.217,0,0,1,1.721,0l5.225,5.225,5.225-5.225a1.217,1.217,0,0,1,1.721,1.721L14.8,18.164a1.217,1.217,0,0,1-1.721,0L6.993,12.078A1.217,1.217,0,0,1,6.993,10.357Z",
    transform: "translate(-2.985 -1.479)",
    fill: "#1383be",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M12.854,3a1.217,1.217,0,0,1,1.217,1.217V18.824a1.217,1.217,0,0,1-2.434,0V4.217A1.217,1.217,0,0,1,12.854,3Z",
    transform: "translate(-1.899 -3)",
    fill: "#1383be",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Download_Icon.f9d310725372ffe809b92e7918c6a3c1.svg";